export default "__VITE_PUBLIC_ASSET__ca3c0ee5__"